import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { NotificationService } from '@services/notification.service';
import { Subject, Subscription } from 'rxjs';
import { ConfirmOtpComponent } from '../confirm-otp/confirm-otp.component';
import { AssignAssessmentComponent } from '../assign-assessment/assign-assessment.component';
import { AssessmentService } from '../../services/assessment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountAdminRole } from '@configs/role.config';
import { placeholdersEnglish, placeholdersPortugese, placeholdersSpanish, AssessmentStatusIds, assessmentTypeId, scheduleCodeEnum } from '@configs/assessment.config';
import { ConfigService } from '@services/config.service';

@Component({
  selector: 'app-patient-landing',
  templateUrl: './patient-landing.component.html',
  styleUrls: ['./patient-landing.component.scss']
})
export class PatientLandingComponent implements OnInit {
  assessmentstatusid: number = 0;
  patientName: any = '';
  phone: any = '';
  doctorName: any = 0;
  assessmentStatusList: any;
  dataSource: any;
  dataSource1: any;
  defualtColumns: string[] = ['patientName', 'phone', 'assessmentstatus', 'assessmentstartdate', 'patientcategory', 'action'];
  displayedColumns: string[] = [];
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
    if(this.dataSource){
      this.dataSource.paginator = paginator;
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  unsubscribe: Subject<void> = new Subject<void>();
  patientListData: any = [];
  assignedRole: any;
  accountAdmin = AccountAdminRole.accountAdmin;
  dynamicColumns: any[] = [];
  langCode: any;
  Center: any = 0;
  CenterList: any;
  doctorList: any;
  collectionId: any;
  isDataNotFound: boolean = false;
  AssessmentStatusIds: any;
  confirmOtp$: Subscription;
  showpdf: boolean = false;
  scheduleCodeEnum: any;
  displayedColumns1: string[] = ['AssessmentName', 'AssessmentType', 'AssessmentStatus', 'TimeTaken', 'score', 'inference', 'remarks'];
  filteredDoctorList: any[] = [];
  doctorListOptions: any[] = [];
  constructor(
    public translate: TranslateService,
    public notificationSer: NotificationService,
    public dialog: MatDialog,
    public AssessmentSer: AssessmentService,
    private activatedRoute: ActivatedRoute,
    public configService: ConfigService,
    public router: Router) {
      this.langCode = localStorage.getItem('language');
      this.collectionId = JSON.parse(sessionStorage.getItem('defaultcollectionid'));
      this.assignedRole = JSON.parse(sessionStorage.getItem('currentUser') || '{}').userRolesCollections[0].rolesAssigned;
      this.scheduleCodeEnum = scheduleCodeEnum;
    }

  ngOnInit(): void {
    this.AssessmentStatusIds = AssessmentStatusIds;
    let data  = ['center', 'doctorName'];
    if (this.assignedRole === this.accountAdmin) {
      data.forEach(col => {
        this.displayedColumns.push(col)
        this.dynamicColumns.push({ key: col, value: this.columnTranslation(col)});
      })
      this.defualtColumns.forEach(d => {
        this.displayedColumns.push(d)
      })
    } else {
      this.displayedColumns = this.defualtColumns;
    }

    this.AssessmentSer.getCenterList(this.collectionId).subscribe(data => {
      this.CenterList = data.data;
    });

    this.AssessmentSer.getDoctors(this.collectionId).subscribe(data => {
      this.doctorList = data.data;
    });

    this.patientList();

    if (this.confirmOtp$) this.confirmOtp$.unsubscribe();
    this.confirmOtp$ = this.AssessmentSer.getconfirmOtp.subscribe((res) => {
      if (res) this.patientList();
    });

    this.AssessmentSer.getAssessmentStatus().subscribe(data => {
      this.assessmentStatusList = data.data;
    });
  }

  onSelectCenter(event) {
    this.doctorListOptions = [];
    this.filteredDoctorList = [];
    this.doctorList.filter(d => {
      if(d.centerName == event.target.value) {
        this.filteredDoctorList.push(d);
      }
    })
    this.doctorListOptions = this.filteredDoctorList;
  }

  columnTranslation(item) {
    if (this.langCode == 'en-US') {
      return placeholdersEnglish[item]
    } else if (this.langCode == 'es-ES') {
      return placeholdersSpanish[item]
    } else if (this.langCode == 'pt-PT') {
      return placeholdersPortugese[item]
    }
  }

  patientList() {
    this.AssessmentSer.getPatientList(this.collectionId).subscribe(data => {
      if (data.data.length > 0) {
        this.patientListData = data.data;
        this.dataSource = new MatTableDataSource(data.data)
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isDataNotFound = false;
        this.setPaginator();
      } else {
        this.isDataNotFound = true;
      }
    });
  }

  onAssignAssessment() {
    this.AssessmentSer.getCountryCodes().subscribe(data => {
      const dialogSubscription1 = this.dialog.open(AssignAssessmentComponent, { minWidth: '950px', data: {countryCodes: data}})
      dialogSubscription1.afterClosed().subscribe(result => {
        this.patientList()
      });
    });
  }

  searchFilter() {
    this.AssessmentSer.searchPatient(this.patientName, this.phone, this.assessmentstatusid, this.collectionId).subscribe((res) => {
      if (res.data.length > 0) {
        this.patientListData = res.data;
        this.dataSource = new MatTableDataSource(res.data)
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isDataNotFound = false;
        this.setPaginator();
      } else {
        this.isDataNotFound = true;
      }
    });
  }

  resetFilter() {
    this.patientName = '';
    this.phone = '';
    this.assessmentstatusid = 0;
    this.doctorName = '';
    this.Center = 0;
    this.patientList();
  }

  setPaginator(): void {
    setTimeout(() => {
      // ------Set translation for pagination------
      if(this.dataSource.paginator) {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.translate.stream([
          'assessment.patientList.pagination.pageLabel',
          'assessment.patientList.pagination.firstPage',
          'assessment.patientList.pagination.lastPage',
          'assessment.patientList.pagination.nextPage',
          'assessment.patientList.pagination.prevPage'
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
            this.dataSource.paginator._intl.itemsPerPageLabel = translation['assessment.patientList.pagination.pageLabel'];
            this.dataSource.paginator._intl.firstPageLabel = translation['assessment.patientList.pagination.firstPage'];
            this.dataSource.paginator._intl.lastPageLabel = translation['assessment.patientList.pagination.lastPage'];
            this.dataSource.paginator._intl.nextPageLabel = translation['assessment.patientList.pagination.nextPage'];
            this.dataSource.paginator._intl.previousPageLabel = translation['assessment.patientList.pagination.prevPage'];

            this.dataSource.paginator._intl.changes.next();
        });
      }
    });
  }

  onEdit(row) {
    this.AssessmentSer.getCountryCodes().subscribe(data => {
      const dialogSubscription1 = this.dialog.open(AssignAssessmentComponent, { minWidth: '950px', data: {row: row, countryCodes: data}})
      dialogSubscription1.afterClosed().subscribe(result => {
        this.patientList()
      });
    });

  }

  onResendOTP(row) {
    this.AssessmentSer.resendOtp(row.patientuuid).subscribe(result => {
      const dialogSubscription = this.dialog.open(ConfirmOtpComponent, { minWidth: '450px', data: row}).afterClosed().subscribe((res) => {
        this.patientList()
      });
    });
  }

  onResendSMS(row) {
    this.AssessmentSer.sendAssessmentUrl(row.patientid, '', row.assessmentStatusId, assessmentTypeId.patientAssisted, scheduleCodeEnum.A1, this.collectionId).subscribe((res) => {

    });
  }

  navogateTopatientDetails(row) {
    this.router.navigate(["../assessmentdetails", row.patientid], { relativeTo: this.activatedRoute });
  }

  patientData: any;
  assessmentData: any;
  exportToPDF(data){
    this.patientData = data
    this.AssessmentSer.getReportPatientAssessmentList(this.collectionId, data?.patientid, '', 0, 0).subscribe(data => {
      if (data.success) {
        if (data.data.length != 0) {
          this.showpdf = true;
          this.assessmentData = data.data;
          this.dataSource1 = new MatTableDataSource(this.assessmentData);
          setTimeout(() => {
            window.print();
          }, 1000);
        }
      }
    });
  }
}
